import { render, staticRenderFns } from "./AnaliseModalDocumentos.vue?vue&type=template&id=65f4ceb2&lang=pug"
import script from "./AnaliseModalDocumentos.vue?vue&type=script&lang=js"
export * from "./AnaliseModalDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports